export default __webpack_public_path__ + "static/media/OpenSans-Semibold.fdf56b22.woff";